// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  .l3-panel-header {
    position: relative;
    text-align: center;
    border-bottom: 1px solid ${(props) => props.theme.colorPalette.gray[500]};
    margin: 0 14px;
  }
  .nav-bar-l3-details {
    margin: 0;
    ul {
      width: 100%;
    }
  }
  .nav-bar-item-label {
    width: auto;
  }
  .l2-nav-link {
    justify-content: space-between;
  }

  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    .nav-bar-l3-panel-new-design {
      .l3-panel-header {
        display: flex;
        margin: 0;
        padding: 17px 16px;
        align-items: center;
        column-gap: 10px;
        min-height: unset;
        background: #f3f3f3;
        border-bottom: none;
      }

      .nav-bar-l3-details {
        width: 100%;
        box-sizing: border-box;
        padding: 24px 32px;
      }
    }
  }
`;
